<template>
  <div class="pager">
    <span class="pager-meta">共 {{ total }} 条 · 第 {{ page }} / {{ totalPages }} 页</span>
    <div class="pager-actions">
      <button type="button" class="btn btn-edit btn-sm" :disabled="page <= 1 || total <= 0" @click="goPrev">上一页</button>
      <button type="button" class="btn btn-edit btn-sm" :disabled="page >= totalPages || total <= 0" @click="goNext">下一页</button>
      <FancySelect
        :model-value="pageSize"
        size="sm"
        :options="pageSizeOptions"
        aria-label="每页条数"
        @update:model-value="onPageSizeChange"
      />
    </div>
  </div>
  <p v-if="tip" class="muted pager-tip">{{ tip }}</p>
</template>

<script>
import FancySelect from '@/components/FancySelect.vue'
import { LIST_PAGE_SIZE_OPTIONS, totalPagesFor } from '@/utils/listPager'

export default {
  name: 'ListPager',
  components: { FancySelect },
  props: {
    total: { type: Number, default: 0 },
    page: { type: Number, default: 1 },
    pageSize: { type: Number, default: 10 },
    tip: { type: String, default: '' },
  },
  emits: ['update:page', 'update:pageSize'],
  computed: {
    pageSizeOptions() {
      return LIST_PAGE_SIZE_OPTIONS
    },
    totalPages() {
      return totalPagesFor(this.total, this.pageSize)
    },
  },
  methods: {
    goPrev() {
      if (this.page > 1) this.$emit('update:page', this.page - 1)
    },
    goNext() {
      if (this.page < this.totalPages) this.$emit('update:page', this.page + 1)
    },
    onPageSizeChange(size) {
      this.$emit('update:pageSize', size)
      this.$emit('update:page', 1)
    },
  },
}
</script>
